<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    width="720px"
    custom-class="privacy-consent-dialog"
    :title="$t('privacyConsentDialogTitle')"
    :before-close="handleBeforeClose"
  >
    <div class="privacy-consent-body">
      <div class="privacy-consent-meta">
        <span class="privacy-consent-version">{{ $t('privacyContentVersion') }}: {{ notice.noticeVersion || '-' }}</span>
      </div>
      <h3 class="privacy-consent-title">{{ notice.noticeTitle || $t('privacyConsentDefaultTitle') }}</h3>
      <div class="privacy-consent-content ql-editor" v-html="notice.noticeContent || ''"></div>

      <div class="privacy-consent-checks">
        <el-checkbox v-model="hasReadNotice">
          {{ $t('privacyConsentReadCheckbox') }}
        </el-checkbox>
        <el-checkbox v-model="hasConsentedPersonalInfo">
          {{ $t('privacyConsentPersonalInfoCheckbox') }}
        </el-checkbox>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="submitting" :disabled="!canConfirm" @click="handleConfirm">
        {{ $t('confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'PrivacyNoticeConsentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    notice: {
      type: Object,
      default() {
        return {};
      },
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasReadNotice: false,
      hasConsentedPersonalInfo: false,
    };
  },
  computed: {
    canConfirm() {
      return this.hasReadNotice && this.hasConsentedPersonalInfo;
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.resetChecks();
      }
    },
    'notice.noticeVersion'() {
      this.resetChecks();
    },
  },
  methods: {
    resetChecks() {
      this.hasReadNotice = false;
      this.hasConsentedPersonalInfo = false;
    },
    handleConfirm() {
      if (!this.canConfirm) {
        return;
      }
      this.$emit('confirm', {
        privacyNoticeRead: true,
        personalInfoConsent: true,
      });
    },
    handleBeforeClose() {
      this.$emit('request-close');
    },
  },
};
</script>

<style scoped lang="less">
.privacy-consent-body {
  .privacy-consent-meta {
    margin-bottom: 12px;
    color: #6b7280;
    font-size: 13px;
  }

  .privacy-consent-title {
    margin: 0 0 12px;
    font-size: 18px;
    color: #111827;
  }

  .privacy-consent-content {
    max-height: 320px;
    overflow-y: auto;
    padding: 16px;
    margin-bottom: 20px;
    line-height: 1.6;
    color: #374151;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
  }

  /deep/ .privacy-consent-content ul,
  /deep/ .privacy-consent-content ol {
    padding-left: 1.5em;
  }

  .privacy-consent-checks {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}

@media (max-width: 768px) {
  /deep/ .privacy-consent-dialog {
    width: calc(100vw - 24px) !important;
    margin-top: 5vh !important;
  }
}
</style>
